export const validationSchemaCreator = fields => {
  const validationSchema = {};

  fields.forEach(field => {
    if (!field.showCondition) validationSchema[field.key] = field.required;
  });

  return validationSchema;
};